import React, {useEffect, useState} from 'react';
import OrderService from "../../../API/orders/orders/organization/OrderService";
import OrderEconomicTable from "../../../components/UI/table/orders/organization/economic/OrderEconomicTable";
import {EditLocalStoragePagesData} from "../../../utils/EditLocalStoragePagesData";
import {constantsErrorMessages} from "../../../Constants";
import ModalAlert from "../../../components/UI/table/customer-detales/ModalAlert";
import {BreadcrumbsComponent} from "../../../components/UI/breadcrumb/BreadcrumbComponent";
import {Box} from "@mui/system";
import dayjs from "dayjs";
import DataUtil from "../../../utils/common/DataUtil";
import {calcFilterData} from "../../../utils/common/calcFilterData";
import {OrderEconomicTableFilterData} from "../../../data/FilterTables/OrderEconomicTableFilterData";
import {EMPTY_ORDER_NUMBER_FILTER, EMPTY_CUSTOMER_NUMBER_FILTER, EMPTY_CUSTOMER_FILTER, EMPTY_HEADER_FILTER, EMPTY_PLAN_FILTER, EMPTY_MODEL_FILTER} from "../../../data/OrderStatus";
import OrderUtil from "../../../utils/orders/OrderUtil";

const OrdersEconomic = () => {
    const startInitValue = dayjs().date(1)
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState(data)
    const [globalFilter, setGlobalFilter] = useState('');
    const [columnsFilter, setColumnsFilter] = useState([]);
    const [alertData, setAlertData] = useState({});
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })
    const [customerList, setCustomerList] = useState([]);
    const [nameList, setNameList] = useState([]);
    const [modelList, setModelList] = useState([]);
    const [planningList, setPlanningList] = useState([]);
    const [numberList, setNumberList] = useState([]);
    const [numberCustomerList, setNumberCustomerList] = useState([]);
    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData("organization/economic/planning", "pageSize", nextState.pageSize)
        }
    }
    const handleSearchQuery = (searchQuery, prevData, pageSize, isColumnFilters) => {
        const newColumnsFilter = isColumnFilters ? searchQuery : columnsFilter
        const newGlobalFilter = isColumnFilters ? globalFilter : searchQuery || ""

        const data = [...prevData]
        const globalFilterData = newGlobalFilter ? calcFilterData(data, newGlobalFilter, OrderEconomicTableFilterData) : data
        const newData = (newColumnsFilter || []).reduce((accumulator, currentValue) => {
            if (!currentValue?.id) {
                return accumulator
            }
            const columnSetting = OrderEconomicTableFilterData.find(el => el.idFromColumnFilter === currentValue.id)
            if (!columnSetting) {
                return accumulator
            }
            return calcFilterData(accumulator, currentValue?.value, [columnSetting])
        }, globalFilterData);

        setFilteredData(newData)

        tableOptionsHandle({
            ...tableOptions,
            totalElements: newData.length,
            pageSize: pageSize ? pageSize : tableOptions?.pageSize
        })

        if (isColumnFilters) {
            setColumnsFilter(searchQuery)
        } else {
            setGlobalFilter(searchQuery || "")
            if (searchQuery !== globalFilter) {
                EditLocalStoragePagesData(`organization/economic/planning`, "searchQuery", searchQuery)
            }
        }
    }
    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[`organization/economic/planning`]?.pageSize
        const searchQuery = pagesData[`organization/economic/planning`]?.searchQuery

        return {searchQuery, pageSize}
    }


    useEffect(() => {
        const {searchQuery, pageSize} = getStartPageSize()
        OrderService.getByEconomicPlan().then(function (response) {
            const data = response.data;
            setCustomerList(DataUtil.getListField(data, 'customerName', EMPTY_CUSTOMER_FILTER));
            setNameList(DataUtil.getListChildField(data, 'header', 'name', EMPTY_HEADER_FILTER));
            setModelList(OrderUtil.getEstimateModuleNamesList(data, EMPTY_MODEL_FILTER));
            setPlanningList(DataUtil.getListChildField(data, 'plan', 'name', EMPTY_PLAN_FILTER));
            setNumberList(DataUtil.getListField(data, 'number', EMPTY_ORDER_NUMBER_FILTER));
            setNumberCustomerList(DataUtil.getListField(data, 'numberCustomer', EMPTY_CUSTOMER_NUMBER_FILTER));
            handleSearchQuery(searchQuery, data, pageSize)
            setData(data);
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, []);

    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }

    return (
        <Box sx={{padding: "0 30px"}}>
            <BreadcrumbsComponent
                page={"Планирование"}
                path={[
                    {name: "Главная", href: "/"},
                ]}/>
            <OrderEconomicTable
                data={data}
                setData={setData}
                tableOptions={tableOptions}
                tableOptionsHandle={tableOptionsHandle}
                handleModalAlert={handleModalAlert}
                startInitValue={startInitValue}
                customerList={customerList}
                nameList={nameList}
                modelList={modelList}
                planningList={planningList}
                numberList={numberList}
                numberCustomerList={numberCustomerList}
                planning={true}
                globalFilter={globalFilter}
                filteredData={filteredData}
                handleSearchQuery={handleSearchQuery}
                columnsFilter={columnsFilter}
            />
            <ModalAlert data={alertData} onClose={() => setAlertData((alert) => {
                return {...alert, open: false}
            })}/>
        </Box>
    );
};

export default OrdersEconomic;